import React from "react";
import { useNetwork } from "context/NetworkContext";

const OfflineBanner = () => {
  const { online } = useNetwork();

  if (online) return null;

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "tomato",
        color: "#ffffff",
        textAlign: "center",
        padding: "20px",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        fontWeight: "bold",
      }}
    >
      ⚠️ No internet connection. Some features may not work.
    </div>
  );
};

export default OfflineBanner;
